export const PLP_RESULTS_UPDATE_EVENT = 'plp/results-update';
export const PLP_FACET_UPDATE_EVENT = 'plp/facet-update';
export const PLP_GRID_UPDATE_EVENT = 'plp/grid-update';

export enum EUserAction {
  CATEGORY = 'category',
  FACET = 'facet',
  PAGINATION = 'pagination',
  SORT_ORDER = 'sort_order',
  RESULT_COUNT = 'result_count',
  BROWSER_ACTION = 'browser_action', // back or forward
}

export const PLP_UPDATE_EVENT = 'plp/update';
